// extracted by mini-css-extract-plugin
export default {"btop":"_4dda15767c _0ddb7ce0a7 _3865f03ebb","icon":"d9c59cc7ae _106f2fb92a","btoppink":"_7b7ab3633f _0100177987"};